__turbopack_context__.v({
  "image": "HeroImage-module-scss-module__IGZW9W__image",
});
